export const OffersMultiplierMock = {
  id: 'off-12345',
  title: 'Earn 150,000 Bonus Points',
  startDate: '1-Aug-25',
  endDate: '1-Sep-25',
  stayStartDate: '1-Aug-25',
  stayEndDate: '1-Sep-25',
  bookingStartDate: '1-Aug-25',
  bookingEndDate: '1-Sep-25',
  clusterCode: 'LTS',
  minimumStay: 1,
  memberLevel: ['E'],
  searchable: 'TRUE',
  url: 'www.marriott.com/offers/first-card-off-12345',
  trackingValue: 'CCOFFER-US-CH-SCOTOP-0513-ACQ_FNA_3-6TVB-GSMP-12345',
  type: 'Single Card',
  parentOfferType: 'Merchandising Offer',
  status: 'In Market',
  rpcCode: '0513',
  offerCode: 'ACQ_PT150k',
  assetId:
    'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvbGMvZW1lYS9od3MvbS9taWxjYi9lbl91cy9waG90by91bmxpbWl0ZWQvYXNzZXRzL2xjLW1pbGNiLXJvb2Z0b3AtcG9vbC0xOTY1OC5qcGc=',
  secondaryAssetId:
    'L2NvbnRlbnQvZGFtL21hcnJpb3R0LWRpZ2l0YWwvZGlnaXRhbC1tZXJjaGFuZGlzaW5nL3VzLWNhbmFkYS9lbl91cy9jb2JyYW5kLWNhcmRzL2Fzc2V0cy9wZHQtVVNNVC00NTB4MjgyLTUzNDU1NzQ3MTY4MDMzOC5wbmc=',
  descriptionTeaser:
    'Earn 150,000 Bonus Points after spending $6,000 on eligible purchases within the first 3 months of account opening.*',
  ctaLabel: 'Learn More',
  ctaLink: 'https://creditcards.chase.com/a1/marriottbonvoyboundless/aep/LTO?CELL=6ZL1&SPID=HR8R',
  ctaExtInd: 'TRUE',
  detailsTitle: 'Maximize Your Rewards',
  descriptionBody1:
    'Earn 150,000 Bonus Points after spending $6,000 on eligible purchases within the first 3 months of account opening.*',
  detailsSubTitle: 'Maximize Your Rewards',
  descriptionBody2:
    'Earn 150,000 Bonus Points after spending $6,000 on eligible purchases within the first 3 months of account opening.*',
  tncCta: [
    {
      label: 'T&C 1',
      link: 'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62027.html',
      extInd: true,
      details: 'TNC1 Details',
    },
    {
      label: 'T&C 2',
      link: 'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62027.html',
      extInd: false,
      details: 'TNC2 Details',
    },
    {
      label: 'T&C 3',
      link: 'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62027.html',
      extInd: true,
      details: 'TNC3 Details',
    },
  ],
  bulletsTitle: 'At a Glance',
  needToKnowBullets: [
    {
      text: 'Earn 6X points with the Marriott Bonvoy Brilliant\u00ae Card.\u2021',
      icon: 'icon-more-points-on-stays',
    },
    {
      text: 'Earn up to 10X points from Marriott Bonvoy for being a Marriott Bonvoy member.\u2021',
      icon: 'icon-more-points-on-stays',
    },
    {
      text: 'Earn up to 5X points from Marriott Bonvoy with the 50% Bonus Points on Stays, a benefit available with your complimentary Platinum Elite status.\u2021',
      icon: 'icon-more-points-on-stays',
    },
  ],
  merchandisingOffer: {
    singleCard: {
      multiplier: {
        eyebrow: 'Points Earned With Your Stay',
        title: 'Marriott Bonvoy Points Earned',
        points: [
          {
            text: '17X',
            description: 'Earn up to 17X total points for every $1 spent at hotels participating in Marriott Bonvoy',
          },
          {
            text: '3X',
            description:
              'Earn 3X Marriott Bonvoy points for every $1 on the first $6,000 spent in combined purchases annually on gas stations, grocery stores and dining.',
          },
          {
            text: '2X',
            description: 'Earn 2X points per $1 spent on other travel purchases',
          },
        ],
      },
      highlight: {
        title: 'Marriott Bonvoy Card Features & Benefits',
        cards: [
          {
            icon: 'icon-free-night-certificates',
            title: 'Marriott Bonvoy Silver Elite Status',
            description:
              'Stay more to earn more Elite Night Credits to achieve the next level of Elite status or spend $35,000 on your card in a calendar year to reach Gold Elite status.',
            ctaLabel: 'Learn More',
            ctaLink: 'https://www.marriott.com/loyalty/member-benefits.mi',
          },
          {
            icon: 'icon-more-points-on-stays',
            title: 'Free Night Award',
            description:
              "Free Night Award (valued up to 35,000 points) every anniversary year. Plus, you can redeem or purchase up to 15,000 points to combine with your free night award so you can access even more hotels and resorts you'll love. Certain hotels have resort fees.",
            ctaLabel: 'Learn More',
            ctaLink: 'https://www.marriott.com/loyalty/redeem/free-night-award-redemption.mi',
          },
          {
            icon: 'icon-elite-night-certificates',
            title: 'Elite Night Credits',
            description:
              '15 Elite Night Credts every calendar year. And you can earn one Elite Night Credit for every $5,000 you spend with no limit on how many Elite Night Credits.',
            ctaLabel: 'Learn More',
            ctaLink: 'https://help.marriott.com/s/article/Article-22162',
          },
          {
            icon: 'icon-more-points-on-stays',
            title: 'Free Night Award',
            description:
              'Receive 1 Free Night Award every year after your Card renewal month. Award can be used for one night (redemption level at or under 85,000 Marriott Bonvoy\u00ae points) at hotels participating in Marriott Bonvoy\u00ae. Certain hotels have resort fees.\u2021',
            ctaLabel: 'See Text',
            ctaLink: 'https://help.marriott.com/s/article/Article-22162',
          },
          {
            icon: 'icon-more-points-on-stays',
            title: 'More Points on Stays',
            description:
              'Earn 50% more points on every eligible hotel purchase, including on room rate and other incidentals that can be charged to your room, such as dining and spa.\u2021',
            ctaLabel: 'Read Now',
            ctaLink: 'https://help.marriott.com/s/article/Article-22162',
          },
          {
            icon: 'icon-internet',
            title: 'Free In-Room Wi-Fi',
            description: 'Enjoy our fastest Internet connection absolutely free.',
            ctaLabel: 'Learn More',
            ctaLink: 'https://help.marriott.com/s/article/Article-22162',
          },
        ],
      },
    },
  },
  contentBlock: 'Free Form Text',
  termsAndConditions: 'Earning Points: See your Card Rewards Program Agreement for more details.',
  properties: [
    {
      id: 'nycmq',
      name: 'NewYork Marquis',
      nickName: 'new-york-marquis',
      city: 'New York',
      cityCode: 'new.york',
      stateProvince: 'New York',
      statecode: 'NY',
      country: 'United States',
      countryCode: 'USA',
      brandName: 'Marriott',
      brandCode: 'MC',
      outlets: [],
    },
  ],
};
